import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparison } from '../data/content';
export function ComparisonSection() {
  return <section className="border-b border-line bg-panel py-20 sm:py-24" data-id="element-37" data-mp="3e69aq2wqlww4">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-38" data-mp="39dpokhjzhtfp">
        <div className="max-w-3xl" data-id="element-39" data-mp="34fo53vinbs3p">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-40" data-mp="34emshmlzexjv">
            Before vs. after
          </p>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl" data-id="element-41" data-mp="2zhwf571kag25">
            Stop improvising. Start coaching with a system.
          </h2>
        </div>

        <div className="mt-12 border border-line" data-id="element-42" data-mp="2qhq2tohlnm4k">
          <div className="hidden grid-cols-2 divide-x divide-line border-b border-line sm:grid" data-id="element-43" data-mp="2lhtxnlx61onf">
            <p className="px-6 py-4 text-[11px] font-semibold uppercase tracking-[0.18em] text-white/35" data-id="element-44" data-mp="onh3hl2zt7ot">
              Without the system
            </p>
            <p className="px-6 py-4 text-[11px] font-semibold uppercase tracking-[0.18em] text-acid" data-id="element-45" data-mp="3af4d2dy6tnhy">
              With the system
            </p>
          </div>

          <ul className="divide-y divide-line" data-id="element-46" data-mp="3ei9cu8qvvb2w">
            {comparison.map(row => <li key={row.without} className="grid sm:grid-cols-2 sm:divide-x sm:divide-line" data-id="element-47" data-mp="30i8bytamc3nf">
                <div className="flex items-start gap-3 bg-night px-6 py-5" data-id="element-48" data-mp="3t5m3gbvjs705">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-white/25" aria-hidden="true" data-id="element-49" data-mp="3t6dwbexrfqmq" />
                  <span className="text-sm leading-relaxed text-white/45 line-through decoration-white/20" data-id="element-50" data-mp="3jgkn2kl3bnln">
                    {row.without}
                  </span>
                </div>
                <div className="flex items-start gap-3 border-t border-line px-6 py-5 sm:border-t-0" data-id="element-51" data-mp="fykdj0zvza5x">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-acid" aria-hidden="true" data-id="element-52" data-mp="kqatbmhleq4q" />
                  <span className="text-sm font-medium leading-relaxed text-white" data-id="element-53" data-mp="ujoqo0hz9apj">
                    {row.with}
                  </span>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}